module.exports = __webpack_public_path__ + "static/img/avatar-women.8ab86411.png";